module.exports = __webpack_public_path__ + "static/media/photo30.dd1b5d56.jpg";